export default function getResource(label, vars = []) {
    const resources = {
        productImage: 'Product Image for sku'
    };

    return resources[label];
}
